import React, { useEffect, useMemo, useState } from "react";
import { Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import { Divider, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { styled } from "@mui/material/styles";

import { setSelectDepartment } from "../../../../../redux/slices/others/projectCodeSlice";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  "& .MuiToggleButtonGroup-grouped": {
    margin: theme.spacing(0.5),
    border: 0,
    "&.Mui-disabled": {
      border: 0,
    },
    "&:not(:first-of-type)": {
      borderRadius: theme.shape.borderRadius,
    },
    "&:first-of-type": {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

const MinistryOptions = ({ handleSelectMinistries }) => {
  const dispatch = useDispatch();

  const { isLoading, ministries, selectMinistry, selectDepartment, ministry } =
    useSelector((state) => ({
      ministries: state.utilsReducer.dropdownItems.ministries,
      selectMinistry: state.projectCodeReducer.selectMinistry,
      selectDepartment: state.projectCodeReducer.selectDepartment,
      ministry: state.projectCodeReducer.ministry,
      isLoading: state.projectCodeReducer.isLoading,
    }));

  return (
    <Card className='mb-3'>
      <Card.Header className='pb-0 px-3'>
        Sila pilih kod kementerian untuk melihat senarai projek dibawah
        kementerian tersebut.
      </Card.Header>
      <Card.Body className='p-2'>
        <StyledToggleButtonGroup
          className='d-flex'
          size='small'
          value={selectMinistry}
          aria-label='select ministries'
          onChange={handleSelectMinistries}
          exclusive
        >
          {ministries?.map((item) => (
            <ToggleButton
              key={item.code}
              className='flex-fill fw-bolder'
              value={item.code}
              color='primary'
            >
              <div>
                <div className='m-0'>D{item.code}</div>
                <div className='m-0'>{item.short_form}</div>
              </div>
            </ToggleButton>
          ))}
        </StyledToggleButtonGroup>
        <div className='px-1 py-2'>
          <Select
            isSearchable
            isClearable
            placeholder='Pilih Jabatan'
            options={ministry?.departments || []}
            value={selectDepartment}
            onChange={(value) => dispatch(setSelectDepartment(value))}
            noOptionsMessage={() => "Tiada pilihan"}
            isDisabled={isLoading}
            components={{
              IndicatorSeparator: () => null,
            }}
            menuPortalTarget={document.body}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: "#ced4da",
                backgroundColor: state.isDisabled ? "#e2e8ee" : "#FFF",
              }),
              singleValue: (baseStyles, state) => ({
                ...baseStyles,
                color: state.isDisabled ? "rgb(84, 84, 84)" : "#495057", // Change text color to black when disabled
              }),
              placeholder: (baseStyles, state) => ({
                ...baseStyles,
                color: state.isDisabled ? "rgb(84, 84, 84)" : "#495057", // Change placeholder color to black when disabled
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999, // bring to front
              }),
            }}
          />
        </div>
      </Card.Body>
    </Card>
  );
};

export default MinistryOptions;
